export const ROUTE_MAIN_NAME = "main-route";
export const ROUTE_HOME_NAME = "home-route";
export const ROUTE_ERROR_SESSION_EXPIRED_NAME = "error-session-expired";
export const ROUTE_ERROR_SERVICE_UNAVAILABLE_NAME = "error-service-unavailable";
export const ROUTE_ERROR_APP_LOAD_FAILED_NAME = "error-app-load-failed";

export const ROUTE_ERROR_SESSION_EXPIRED_PATH = "/error/session-expired";
export const ROUTE_ERROR_SERVICE_UNAVAILABLE_PATH =
  "/error/service-unavailable";
export const ROUTE_ERROR_APP_LOAD_FAILED_PATH = "/error/app-load-failed";
